import { gql } from '@apollo/client';

const FLAGGED_STUDIES_COUNT_QUERY = gql`
  query flaggedStudiesCount($filter: FlaggedStudiesFilter) {
    flaggedStudiesCount(filter: $filter)
  }
`;

export default FLAGGED_STUDIES_COUNT_QUERY;
